import { Price } from "@/types/price";
import * as Sentry from "@sentry/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { PaymentFormControl } from "./PaymentFormControl";
import { PaymentFormData, PaymentFormProps } from "./types";

export type { PaymentFormData, PaymentFormProps } from "./types";

export default function PaymentForm({
    HeaderComponent,
    BetweenPricingAndPaymentComponent,
    onPaymentComplete,
}: PaymentFormProps) {
    const [paymentFormData, setPaymentFormData] = useState<
        PaymentFormData | undefined
    >();
    const [selectedPrice, setSelectedPrice] = useState<Price | null>(null);

    const getPaymentFormData = async () => {
        const { data } = await axios.get<PaymentFormData | undefined>(
            route("client.paymentFormData"),
        );
        if (data) {
            setPaymentFormData(data);
            setSelectedPrice(
                data.prices?.find((price) => price.default) ?? null,
            );
        } else {
            alert(
                "Something went wrong! Please refresh the page and try again.",
            );
            Sentry.captureException(
                "Payment form data not returned from server. Client may have had a stale session.",
            );
        }
    };

    useEffect(() => {
        void getPaymentFormData();
    }, []);

    if (!paymentFormData || !selectedPrice) {
        return null;
    }

    return (
        <PaymentFormControl
            HeaderComponent={HeaderComponent}
            BetweenPricingAndPaymentComponent={
                BetweenPricingAndPaymentComponent
            }
            paymentFormData={paymentFormData}
            selectedPrice={selectedPrice}
            onPaymentComplete={onPaymentComplete}
        />
    );
}
